import { List, styled } from '@mui/material'

export const StyledList = styled(List)(({ theme }) => ({
  minHeight: 0,
  paddingBottom: theme.spacing(1),
}))
